export default "__VITE_ASSET__DD3yJg_S__"